module.exports = __webpack_public_path__ + "static/media/I_live_to_serve_the_hypno_virus.820d504d.mp3";